import { connect } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { PanelGroup } from 'react-bootstrap';
import { waitForInvData } from 'wsm-srp-utilities';
import { isBrowser } from 'ws-scripts/modules/environment';
import { addAllFacetItem } from '../utilities/add-all-facet-item';
import FacetGroup from '../components/FacetGroup';
import ErrorBoundary from '../components/ErrorBoundary';

class WidgetContainer extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			renderPortal: false
		};

		if (isBrowser) {
			waitForInvData(this, 'facet');
		}
	}

	componentDidMount() {
		if (window && window.DDC && window.DDC.pubsub) {
			// Subscribe to ws-inv-filters modal display events
			window.DDC.pubsub.subscribe('ws-inv-filters/modal-show', () => {
				this.setState({ renderPortal: true });
			});
			window.DDC.pubsub.subscribe('ws-inv-filters/modal-hide', () => {
				this.setState({ renderPortal: false });
				window.scrollTo(0, 0);
			});
		}
	}

	/**
	 * Create a FacetGroup component for each object in data.facets
	 *
	 * @param data {Object} InvData.getFacets() response
	 * @returns {FacetGroup[]} FacetGroup components
	 */
	static getFacetGroups(data) {
		const appliedFilters = window.DDC.InvData.getAppliedFilters();
		return data.facets.map(facet => {
			const facetSelections = appliedFilters.find(
				filter => filter.id === facet.id
			);
			// Create "All" facet selection for single select facets
			// and set selected to true if no other facet values are selected
			// TODO this should be added to the facet upstream.
			if (!facet.multiselect) {
				// eslint-disable-next-line no-param-reassign
				facet.values = addAllFacetItem(facet.values, facet.allLabel);
			}
			return (
				<FacetGroup
					facet={facet}
					selectedValues={
						facetSelections ? facetSelections.values : []
					}
					key={`facetgroup-${facet.id}`}
				/>
			);
		});
	}

	getFacetGroupsForRender() {
		let facetGroups = null;
		if (!this.noFacetsAvailable()) {
			facetGroups = WidgetContainer.getFacetGroups(
				window.DDC.InvData.getFacets()
			);
		}
		return facetGroups;
	}

	getFacetList() {
		return (
			<ErrorBoundary>
				<PanelGroup id="facet-list" className="facet-list">
					{this.getFacetGroupsForRender()}
				</PanelGroup>
			</ErrorBoundary>
		);
	}

	/* eslint class-methods-use-this: 0 */
	noFacetsAvailable() {
		return (
			!isBrowser ||
			!window.DDC.InvData ||
			!window.DDC.InvData.facets ||
			Object.keys(window.DDC.InvData.facets).length === 0 ||
			window.DDC.InvData.facets.length === 0
		);
	}

	render() {
		if (this.noFacetsAvailable()) {
			return null;
		}

		const [modalContainer] = document.querySelectorAll(
			'.modal-filters-react-portal'
		);

		const facetList = this.getFacetList();

		// Renders the `facetList` into a modal based on event type
		if (modalContainer && this.state.renderPortal) {
			return ReactDOM.createPortal(facetList, modalContainer);
		}

		return facetList;
	}
}

WidgetContainer.propTypes = {};

const mapStateToProps = _state => {
	const {
		requestData: { widgetName }
	} = _state;
	return { widgetName };
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
